export const calculateUserQuantity = (user) => {
  if (!user) return 0;
  
  const inventoryQuantity =
    user.inventoryItems?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;
  const kitQuantity =
    user.kitInventoryItems?.reduce((sum, kitItem) => sum + (kitItem.quantity || 0), 0) || 0;

  return inventoryQuantity + kitQuantity;
};

export const calculateTotalCartQuantity = (users) => {
  if (!users || !Array.isArray(users)) return 0;
  
  return users.reduce((total, user) => total + calculateUserQuantity(user), 0);
}; 